<template>
  <div>
    <b-container class="wide">
      <head-block :title="$t('title.customer.product_sale_lines', { product_name: selectedProductName ? selectedProductName : '' })" />
      <div class="mb-3 mt-3">
        <b-button
          variant="outline-primary"
          :to="$router.currentRoute.path.includes('detail') ? {
            name: 'product-sheet-details', params: { productSheetId: $route.params.productSheetId }
          } : { name: 'products' }"
          v-html="$t('links.admin.go_back')"
        >
        </b-button>
      </div>
      <content-table
        :fields="fields"
        :items="productSaleLines"
        :slots="templates"
        :defaultSlots="defaultSlots"
        head-variant="dark"
      >
        <!--Formatted date-->
        <template slot="dateOfSale" slot-scope="data"
        >{{ formatDate(data.tbl.item.dateOfSale) }}</template>
        <template slot="quantity" slot-scope="data">
          <span v-if="Number(data.tbl.item.quantity)"
          >{{ formatNumber(data.tbl.item.quantity, 2) }}</span>
        </template>
        <template slot="pricePerPiece" slot-scope="data"
        >{{ formatNumber(data.tbl.item.pricePerPiece, 2) }}</template>
        <template slot="totalAmount" slot-scope="data"
        >{{ formatNumber(data.tbl.item.totalAmount, 2) }}</template>
        <template slot="share" slot-scope="data"
        >{{ formatNumber(data.tbl.item.share, 2) }}</template>
        <template slot="bottom-row" v-if="productSaleLines.length">
          <td class="text-center font-weight-bold bg-light-blue">{{ $t('table.sales.title_total') }}</td>
          <td class="text-center font-weight-bold bg-light-blue">{{ formatNumber(getTotal(productSaleLines, 'quantity'), 2) }}</td>
          <td class="text-center font-weight-bold bg-light-blue"></td>
          <td class="text-center font-weight-bold bg-light-blue">{{ formatNumber(getTotal(productSaleLines, 'totalAmount'), 2) }}</td>
          <td class="text-center font-weight-bold bg-light-blue">{{ formatNumber(getTotal(productSaleLines, 'share'), 2) }}</td>
        </template>
      </content-table>
      <span v-if="!loader.isActive && !productSaleLines.length" class="no-table-data">
        {{ $t('table.general.no_data') }}
      </span>
    </b-container>
  </div>
</template>

<script>

  import { mapState } from 'vuex'
  import ContentTable from '@base/components/ContentTable'
  import HeadBlock from '@base/components/HeadBlock.vue'
  import ObjectUtils from '@base/mixins/ObjectUtils.vue'
  import Formatting from '@base/mixins/Formatting'
  import TableUtils from '@base/mixins/TableUtils'
  import { USED } from '@base/configs'
  import {mutationTypes} from '@base/store/store-types'

  export default {
    name: 'ProductSalesView',

    components: {
      HeadBlock,
      ContentTable,
    },

    mixins: [ ObjectUtils, TableUtils, Formatting ],

    data() {
      return {
        fields: [
          { key: 'dateOfSale', label: this.$t('table.sales.date_of_sale'), class: 'text-center' },
          { key: 'quantity', label: this.$t('table.sales.quantity'), class: 'text-center' },
          { key: 'pricePerPiece', label: this.$t('table.sales.price'), class: 'text-center' },
          { key: 'totalAmount', label: this.$t('table.sales.total'), class: 'text-center' },
          { key: 'share', label: this.$t('table.sales.share'), class: 'text-center' },
        ],
        templates: [
          { name: 'dateOfSale', field: 'dateOfSale' },
          { name: 'quantity', field: 'quantity' },
          { name: 'pricePerPiece', field: 'pricePerPiece' },
          { name: 'totalAmount', field: 'totalAmount' },
          { name: 'share', field: 'share' },
        ],
        defaultSlots: [
          { name: 'bottom-row' }
        ],
        loading: false,
        selectedProduct: null,
        selectedProductName: null,
      }
    },

    created() {
      this.$store.commit(mutationTypes.SET_PRODUCT_SALE_LINE_LIST, [])
      this.getProductSaleLines()
    },

    computed: {
      ...mapState(['productSaleLines']),
    },

    methods: {

      getProductSaleLines () {
        if (this.loading)
          return
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.dispatch(this.$_actionTypes.GET_PRODUCT_SALE_LINE_LIST, this.$route.params.productId)
          .then((res) => {
            if (res.data && res.data.length) {
              this.selectedProduct = res.data[0].product
            }
            if (this.selectedProduct && this.selectedProduct.name) {
              this.selectedProductName = `${this.selectedProduct.sheetProductId}: ${this.selectedProduct.name}`
            } else {
              if (res.data && !res.data.length) {
                this.selectedProductName = this.selectedProduct.sheetProductId
              } else if (res.data[0].productType === USED) {
                this.selectedProductName = `${this.selectedProduct.sheetProductId}: ${this.$t('table.sales.generic_used_product_name')}`
              } else {
                this.selectedProductName = `${this.selectedProduct.sheetProductId}: ${this.$t('table.sales.generic_new_product_name')}`
              }
            }
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
            this.loading = false
          })
      },
    }
  }

</script>

<style>

</style>
